/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

*,
:host {
  box-sizing: border-box;
  font-size: 1rem;
  font-family: inherit;
}

:host button,
:host input,
:host optgroup,
:host select,
:host textarea {
  font-family: inherit;
}

* {
  text-align: left;
}

:host {
  display: inline-block;
  vertical-align: middle;
  line-height: 3.143rem;
  margin-top: 0.8571428571rem;
  height: 3.2857142857rem;
  text-align: left;
}
:host :focus {
  outline: none;
}
:host div.inputwrapper {
  display: inline-block;
  position: relative;
  vertical-align: middle;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;
  border: 0.0714285714rem solid var(--davinci-color-outline,#8E989D);
  background-color: #FFFFFF;
  background-color: var(--davinci-color-background-input, #FFFFFF);
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
  line-height: 3.143rem;
  height: 3.2857142857rem;
}
:host div.inputwrapper label.placeholder,
:host div.inputwrapper label.label {
  transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
  position: absolute;
  left: 0;
  padding: 0 1.1428571429rem;
  top: 0;
  color: #737F85;
  color: var(--davinci-color-text-lighter, #737F85);
  font-size: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  white-space: nowrap;
  line-height: 3.143rem;
}
:host div.inputwrapper div.input {
  position: relative;
  height: inherit;
  order: 0;
  flex: 1 1 auto;
  align-self: auto;
  height: 3.143rem;
}
:host div.inputwrapper div.input input {
  position: relative;
  font-size: 1rem;
  height: 3.143rem;
  border: 0;
  padding: 0 1.1428571429rem;
  background: rgba(255, 255, 255, 0);
  line-height: 1.57;
  width: 100%;
  text-overflow: ellipsis;
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
}
:host div.inputwrapper div.input input::-ms-clear {
  display: none;
}
:host div.inputwrapper slot {
  order: 0;
  flex: 0 0 auto;
  align-self: auto;
  padding: 0 1.0714285714rem 0 0;
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
}

:host(:not([disabled])) .inputwrapper.focus-within {
  transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
  border: 0.0714285714rem solid var(--davinci-color-primary,#007CC1);
}
:host(:not([disabled])) .inputwrapper.focus-within.selected label.label, :host(:not([disabled])) .inputwrapper.focus-within.notempty label.label, :host(:not([disabled])) .inputwrapper.focus-within label.label {
  transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
  color: var(--davinci-color-primary,#007CC1);
}
:host(:not([disabled])) div.inputwrapper:hover {
  border: 1px solid var(--davinci-color-primary,#007CC1) !important;
}
:host(:not([disabled])) div.inputwrapper:hover label.label {
  color: var(--davinci-color-primary,#007CC1) !important;
}

:host([type=date]) > div.inputwrapper label.label,
:host([placeholder]) > div.inputwrapper label.label,
:host div.inputwrapper.selected label.label,
:host div.inputwrapper.notempty label.label {
  transform: translate(0, -70%);
  padding: 0 0.4285714286rem;
  line-height: 1.2857142857rem;
  left: 0.7142857143rem;
  background-color: #FFFFFF;
  background-color: var(--davinci-color-background, #FFFFFF);
  font-size: 0.8571428571rem;
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
  max-width: 90%;
}

:host([label=""]) > div.inputwrapper label.label,
:host(:not([label])) > div.inputwrapper label.label {
  display: none;
}

:host(:not([placeholder])) > div.inputwrapper label.placeholder,
:host([placeholder=""]) > div.inputwrapper label.placeholder,
:host([placeholder]) > div.inputwrapper.notempty label.placeholder {
  display: none;
}

:host([warning][placeholder]:not([disabled])) div.inputwrapper label.label,
:host([warning][placeholder]:not([disabled])) div.inputwrapper.focus-within label.label {
  color: #F5C413;
  color: var(--davinci-color-warning, #F5C413);
}

:host([warning]:not([disabled])) div.inputwrapper,
:host([warning]:not([disabled])) div.inputwrapper.focus-within {
  border: 0.0714285714rem solid var(--davinci-color-warning,#F5C413);
}
:host([warning]:not([disabled])) div.inputwrapper.selected label.label, :host([warning]:not([disabled])) div.inputwrapper.notempty label.label,
:host([warning]:not([disabled])) div.inputwrapper.focus-within.selected label.label,
:host([warning]:not([disabled])) div.inputwrapper.focus-within.notempty label.label {
  color: #F5C413;
  color: var(--davinci-color-warning, #F5C413);
}

:host([error][placeholder]:not([disabled])) div.inputwrapper label.label,
:host([error][placeholder]:not([disabled])) div.inputwrapper.focus-within label.label {
  color: #EA0823;
  color: var(--davinci-color-error, #EA0823);
}

:host([error]:not([disabled])) div.inputwrapper,
:host([error]:not([disabled])) div.inputwrapper.focus-within {
  border: 0.0714285714rem solid var(--davinci-color-error,#EA0823);
}
:host([error]:not([disabled])) div.inputwrapper.selected label.label, :host([error]:not([disabled])) div.inputwrapper.notempty label.label,
:host([error]:not([disabled])) div.inputwrapper.focus-within.selected label.label,
:host([error]:not([disabled])) div.inputwrapper.focus-within.notempty label.label {
  color: #EA0823;
  color: var(--davinci-color-error, #EA0823);
}

:host([readonly]) > div.inputwrapper {
  background-color: #FBFCFC;
  background-color: var(--davinci-color-background-2, #FBFCFC);
}

:host([disabled]) {
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}
:host([disabled]) div.inputwrapper {
  border: 0.0714285714rem solid var(--davinci-color-outline-light,#C5CACC);
}
:host([disabled]) div.inputwrapper label.label {
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}
:host([disabled]) div.inputwrapper div.input label.placeholder {
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}
:host([disabled]) div.inputwrapper div.input input {
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}

:host([hidden]) {
  display: none;
}`;
export { style };
